module.exports = __webpack_public_path__ + "media/images/icons/icn_049-3163b9ace459e19a4283bf4de48e1fc5.svg";